// extracted by mini-css-extract-plugin
module.exports = {"img":"gallery-image_img__akD2V","form":"gallery-image_form__3MSNj","formupload":"gallery-image_formupload__weJE0"};